import { IntroPresenter } from '@/presentation/presenters/util/introPresenter'

export function useIntroPresenter(presenter: IntroPresenter = new IntroPresenter()) {
  return {
    isExitIntro: presenter.isExitIntro,
    setIsExitIntro: presenter.setIsExitIntro.bind(presenter),
    startTour: presenter.startTour.bind(presenter)
  }
}
